import styled from 'styled-components';
import { Theme } from '@veneer/theme';

export const Container = styled.div<{ $veneerTheme: Theme }>`
  max-width: 1920px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: calc(
    ${({ $veneerTheme }) => $veneerTheme.layout.size8} +
      ${({ $veneerTheme }) => $veneerTheme.layout.size2}
  );
  @media (max-width: 768px) {
    gap: ${({ $veneerTheme }) => $veneerTheme.layout.size8};
  }
`;
